import React, { useState } from "react";
import { Dropdown, Button } from "react-bootstrap";
import {
  FiArrowLeft,
  FiDownload,
  FiPlus,
  FiChevronUp,
  FiFileText,
} from "react-icons/fi";
import AddTicketDetails from "../../modals/hrm/tickets/AddTicketDetails";

// import AddTicketModal from "./AddTicketModal";

const TicketDetailsHeader = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#ffffff",
          padding: "12px 16px",
          borderRadius: "6px",
          marginBottom: "16px",
        }}
      >
        {/* LEFT */}
        <div style={{ marginBottom: "8px" }}>
          <h6
            style={{
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
              fontSize: "15px",
              margin: 0,
            }}
          >
            <a
              href="#"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "#000",
              }}
            >
              <FiArrowLeft style={{ marginRight: "6px" }} />
              Ticket Details
            </a>
          </h6>
        </div>

        {/* RIGHT */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          {/* EXPORT */}
          <Dropdown align="end">
            <Dropdown.Toggle
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                color: "#000",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
              }}
            >
              <FiDownload style={{ marginRight: "5px" }} />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ padding: "10px" }}>
              <Dropdown.Item
                style={{
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              >
                <FiFileText style={{ marginRight: "6px" }} />
                Export as PDF
              </Dropdown.Item>

              <Dropdown.Item
                style={{
                  borderRadius: "6px",
                  fontSize: "14px",
                }}
              >
                <FiFileText style={{ marginRight: "6px" }} />
                Export as Excel
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD TICKET */}
          <Button
            onClick={() => setShowModal(true)}
            style={{
              background: "#ff6b00",
              border: "none",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              padding: "6px 12px",
            }}
          >
            <FiPlus style={{ marginRight: "6px" }} />
            Add Ticket
          </Button>

          {/* COLLAPSE ICON */}
          <div style={{ marginLeft: "4px", cursor: "pointer" }}>
            <FiChevronUp size={18} />
          </div>
        </div>
      </div>

      {/* MODAL */}
      <AddTicketDetails
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default TicketDetailsHeader;